module.exports = __webpack_public_path__ + "static/media/couch.c06990e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/floorPlan/couch.svg
// module id = 1120
// module chunks = 38